<template>
  <div>
    <!--面包屑导航区域-->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>发起支付列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!--面包屑导航区域-->
    <!--卡片视图区-->
    <el-card>
      <!--搜索与添加区域-->
      <el-row :gutter="20">
        <el-col :span="20">
          <el-input
            placeholder="请输入商户编号"
            clearable
            v-model="queryInfo.payOrderno"
            @clear="getOrderList()"
            style="width: 300px"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getOrderList()"
            ></el-button>
          </el-input>
          <el-input
            placeholder="请输入用户名"
            clearable
            v-model="queryInfo.username"
            @clear="getOrderList()"
            style="width: 300px; margin-left: 10px"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getOrderList()"
            ></el-button>
          </el-input>
          <el-input
            placeholder="请输入订单编号"
            clearable
            v-model="queryInfo.orderno"
            @clear="getOrderList()"
            style="width: 300px; margin-left: 10px"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getOrderList()"
            ></el-button>
          </el-input>
          <el-input
            placeholder="请输入手机号"
            clearable
            v-model="queryInfo.username"
            @clear="getOrderList()"
            style="width: 300px"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getOrderList()"
            ></el-button>
          </el-input>

          <el-select
            v-model="queryInfo.storeId"
            placeholder="请选择门店"
            @change="getOrderList()"
            style="margin-left: 10px"
            clearable
            filterable
          >
            <el-option
              v-for="item in storelist"
              :key="item.id"
              :label="item.storename"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-date-picker
            v-model="customdate"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="CustomeDate"
            style="margin: 0 10px"
          >
          </el-date-picker>
          <el-select
            v-model="queryInfo.cardForm"
            clearable
            placeholder="请选择交易类型"
            @change="getOrderList()"
            style="width: 150px"
          >
            <el-option label="平台" value="0"></el-option>
            <el-option label="抖音" value="1"></el-option>
            <el-option label="美团" value="2"></el-option>
            <el-option label="高德" value="7"></el-option>
          </el-select>
          <el-select
            v-model="queryInfo.payStatus"
            clearable
            placeholder="支付状态"
            @change="getOrderList()"
            style="margin: 0 10px; width: 150px"
          >
            <el-option label="未支付" value="0"></el-option>
            <el-option label="已支付" value="1"></el-option>
            <el-option label="已取消" value="2"></el-option>
            <el-option label="已撤销" value="3"></el-option>
          </el-select>
          <el-select
            v-model="queryInfo.isAudit"
            clearable
            placeholder="撤销状态"
            @change="getOrderList()"
            style="margin: 0 10px; width: 150px"
          >
            <el-option label="待审核" value="1"></el-option>
            <el-option label="审核成功" value="2"></el-option>
            <el-option label="审核失败" value="3"></el-option>
          </el-select>
          <el-select
            v-model="queryInfo.status"
            clearable
            placeholder="是否退款"
            @change="getOrderList()"
            style="margin: 0 10px; width: 150px"
          >
            <el-option label="未退款" value="0"></el-option>
            <el-option label="已退款" value="1"></el-option>
            <el-option label="退款失败" value="2"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" style="text-align: right">
          <el-button
            type="primary"
            icon="el-icon-upload"
            @click="exportOrders"
            :loading="exporting"
            v-permission="'btn:order:export'"
            >导出Excel</el-button>
        </el-col>
      </el-row>
      <br />
      <!--搜索与添加区域-->
      <!--用户列表区域-->
      <el-table
        :data="orderlist"
        style="width: 100%"
        ref="invoiceTable"
        stripe
        size="small"
        height="760"
        show-summary
        v-loading="isLoading"
        :row-class-name="tableRowClassName"
        :row-key="row => row.id"
      >
        <!-- <el-table-column label="ID" type="index"  width="50" fixed></el-table-column> -->
        <el-table-column label="序号" width="50" fixed>
          <template slot-scope="scope">
            {{
              (queryInfo.pagenum - 1) * queryInfo.pagesize + scope.$index + 1
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="商户编号"
          prop="payOrderno"
          min-width="110"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="订单编号"
          prop="orderno"
          min-width="110"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="用户名"
          prop="username"
          min-width="100"
        ></el-table-column>
        <el-table-column
          label="店铺名"
          prop="storename"
          min-width="90"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- <el-table-column label="卡名" prop="cardname" width="150" :show-overflow-tooltip="true"></el-table-column> -->
        <el-table-column
          label="卡名"
          prop="cardname"
          min-width="120"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="支付金额"
          prop="price"
          min-width="70"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope" v-if="scope.row.price">
            <span style="color: #ff0000">￥{{ scope.row.price }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="退款金额"
          prop="refundPrice"
          min-width="70"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span style="color: #1989fa" v-if="scope.row.refundPrice"
              >￥{{ scope.row.refundPrice }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="结算金额"
          prop="owneramount"
          min-width="70"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span style="color: #1989fa" v-if="scope.row.owneramount"
              >￥{{ scope.row.owneramount }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="扣点金额"
          prop="pointsamount"
          min-width="70"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span style="color: #1989fa" v-if="scope.row.pointsamount"
              >￥{{ scope.row.pointsamount }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="撤销金额"
          prop="cxPrice"
          min-width="70"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span style="color: #1989fa" v-if="scope.row.cxPrice"
              >￥{{ scope.row.cxPrice }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="来源"
          prop="cardForm"
          min-width="80"
        >
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.cardForm == '0'">平台</el-tag>
            <el-tag type="danger" v-if="scope.row.cardForm == '1'">抖音</el-tag>
            <el-tag type="warning" v-if="scope.row.cardForm == '2'">美团</el-tag>
            <el-tag v-if="scope.row.cardForm == '7'">高德</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            label="支付状态"
            min-width="80"
            :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.payStatus == '0'">
              <el-tag
                  type="info"
              >未支付</el-tag>
            </span>
            <span v-else-if="scope.row.payStatus == '1'">
              <el-tag
                  type="success"
              >已支付</el-tag>
            </span>
            <span v-else-if="scope.row.payStatus == '2'">
              <el-tag
                  type="warning"
              >已取消</el-tag>
            </span>
            <span v-else-if="scope.row.payStatus == '3'">
              <el-tag
                  type="danger"
              >已撤销</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          prop="status"
          min-width="80"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-tag
              type="success"
              v-if="scope.row.status == '0'"
              >未退款</el-tag>
            <el-tag
              type="info"
              v-if="scope.row.status == '1'"
              >已退款</el-tag>
            <el-tag
              type="info"
              v-if="scope.row.status == '2'"
              >退款失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="失败原因"
          prop="error"
          min-width="130"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="退款原因"
          prop="refunddescribe"
          min-width="130"
          :show-overflow-tooltip="true"
        />
        <el-table-column
            label="撤销状态"
            prop="isAudit"
            min-width="80"
            :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-tag
                type="info"
                v-if="scope.row.isAudit == '0'"
            >未撤销</el-tag>
            <el-tag
                type="warning"
                v-if="scope.row.isAudit == '1'"
            >审核中</el-tag>
            <el-tag
                type="success"
                v-if="scope.row.isAudit == '2'"
            >审核成功</el-tag>
            <el-tag
                type="danger"
                v-if="scope.row.isAudit == '3'"
            >审核失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            label="撤销原因"
            prop="auditReason"
            min-width="130"
            :show-overflow-tooltip="true"
        />
        <el-table-column
            label="拒绝原因"
            prop="auditError"
            min-width="130"
            :show-overflow-tooltip="true"
        />
        <el-table-column
            label="个人退款原因"
            prop="personalRefundReason"
            min-width="130"
            :show-overflow-tooltip="true"
        />
        <el-table-column
          label="发起时间"
          prop="createTime"
          min-width="130"
        />
        <el-table-column
          label="支付时间"
          prop="payTime"
          min-width="130"
        />
        <el-table-column
          label="截止时间"
          prop="endPayTime"
          min-width="100"
        />
        <el-table-column label="操作" min-width="240" >
          <template slot-scope="scope">
            <span v-if="scope.row.status == '0' && scope.row.payStatus == '1' && scope.row.cardForm == '1'">
              <el-button type="warning" icon="el-icon-delete" size="mini"
                  @click="DelCard(scope.row)">确认退款</el-button>
            </span>
            <span v-if="scope.row.status == '2' && scope.row.isAudit == '0' && scope.row.payStatus == '1' && scope.row.cardForm != '1'">
              <el-button type="primary" icon="el-icon-delete" size="mini"
                  @click="DelCard(scope.row)">重新退款</el-button>
            </span>
            <span v-if="scope.row.isAudit != '1' && (scope.row.payStatus == '1' || scope.row.payStatus == '3') && scope.row.cxPrice < scope.row.price">
              <el-button type="info" icon="el-icon-delete" size="mini"
                  @click="sxCard(scope.row)">撤销退款</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <!--用户列表区域-->
      <!--分页区域-->
      <br />
      <div align="center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next"
          :total="total"
        >
        </el-pagination>
        <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[1, 5, 10, 20, 50, 100]"  :page-size="queryInfo.pagesize"
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination> -->
      </div>
    </el-card>


    <!--退款对话框-->
    <el-dialog
        title="撤销退款"
        :visible.sync="refundDialogVisible"
        width="65%"
        @close="refundDialogClosed"
    >
      <el-form
          :model="refundForm"
          :rules="refundFormRules"
          ref="refundFormRef"
          label-width="100px">

          <el-form-item label="订单金额" prop="amount">
            {{ refundForm.amount }} 元
          </el-form-item>
          <el-form-item label="剩余可退金额" prop="syAmount">
            {{ refundForm.syAmount }} 元
          </el-form-item>
          <el-form-item label="撤销金额" prop="sendPrice">
            <div>
              <el-input
                  v-model="refundForm.sendPrice"
                  placeholder="请输入撤销金额"
                  style="width: 200px; margin-right: 10px"
                  @input="validateRefundAmount"
                  @keypress="checkNumberInput"
                  @paste="handlePaste"
                  @compositionend="handleCompositionEnd"
                  type="text"
              ></el-input>
              元
            </div>
          </el-form-item>
          <el-form-item label="撤销说明" prop="auditReason">
            <el-input
                type="textarea"
                v-model="refundForm.auditReason"
                placeholder="请输入撤销说明"
                :rows="3"
            ></el-input>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRefund">确定撤销</el-button>
      </span>
    </el-dialog>
    <!--退款对话框-->
  </div>
</template>
<script>
import axios from "axios";
import {saveAs} from "file-saver";
import {Loading} from "element-ui";

export default {
  data() {
    return {
      refundForm: {
        payOrderno: "",
        amount: 0, // 订单金额
        syAmount: 0, //剩余可退金额
        sendPrice: null, // 撤销金额
        auditReason: "", // 撤销说明
      },
      // 退款表单验证规则
      refundFormRules: {
        sendPrice: [
          { required: true, message: "请输入撤销金额", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请输入撤销金额"));
              } else if (isNaN(value)) {
                callback(new Error("撤销金额必须是数字"));
              } else if (parseFloat(value) <= 0) {
                callback(new Error("撤销金额必须大于0"));
              } else if (
                  parseFloat(value) > parseFloat(this.refundForm.amount)
              ) {
                callback(new Error("撤销金额不能超过订单金额"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        auditReason: [
          { required: false, message: "请输入撤销说明", trigger: "blur" },
        ]
      },
      refundDialogVisible: false,
      exporting: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      customdate: "",
      //获取订单列表的参数对象
      queryInfo: {
        payOrderno: "",
        username: "",
        orderno: "",
        payStatus: "",
        status: "",
        cardForm: "",
        storeId: "", // 添加申请退款搜索参数
        startTime: "",
        endTime: "",
        isAudit: "",
        username: "",
        pagenum: 1,
        pagesize: 20,
      },
      orderlist: [],
      storelist: [],
      total: 0,
      loading: false,
      isLoading: true
    };
  },
  created() {
    this.getOrderList();
    this.GetStore();
  },
  methods: {
    async GetStore() {
      const { data: res } = await this.$http.get("store/");
      if (res.status == 0) {
        this.storelist = res.data;
      }
    },
    async getOrderList() {
      this.isLoading = true
      // 先清空列表，避免 Vue 虚拟 DOM 更新冲突
      this.orderlist = [];
      this.queryInfo.pagenum = 1
      try {
        const { data: res } = await this.$http.post("sendPay/getList", this.queryInfo);

        // 检查响应状态和数据是否存在
        if (res.status == 1) {
          if (res.data.totalCount > 0) {
            this.total = res.data.totalCount;
          }

          // 处理订单列表数据
          if (res.data.list && Array.isArray(res.data.list)) {
            // 使用 $nextTick 确保 DOM 更新完成后再赋值
            this.$nextTick(() => {
              this.orderlist = res.data.list;
              this.isLoading = false;
            });
          } else {
            this.orderlist = [];
            this.isLoading = false;
          }
        } else {
          // 请求失败或数据格式不正确
          this.total = 0;
          this.orderlist = [];
          this.isLoading = false;
          if (res && res.message) {
            this.$message.error(res.message);
          }
        }
        console.log("订单列表数据:", this.orderlist);
      } catch (error) {
        this.isLoading = false;
        this.total = 0;
        this.orderlist = [];
        console.error("获取订单列表失败:", error);
        this.$message.error("获取订单列表失败");
      }
    },
    async getFyOrderList() {
      this.isLoading = true
      const { data: res } = await this.$http.post("sendPay/getList", this.queryInfo);
      this.isLoading = false
      if (res.status == 1) {
        if (res.data.totalCount > 0) {
          this.total = res.data.totalCount;
        }

        // 处理订单列表数据
        this.orderlist = res.data.list
      }
      this.isLoading = false;
      console.log("订单列表数据:", this.orderlist);
    },
    handleSizeChange(newSize) {
      this.isLoading = true;
      // console.log(newSize)
      this.queryInfo.pagesize = newSize;
      this.getFyOrderList();
    },
    handleCurrentChange(newPage) {
      this.isLoading = true;
      // console.log(newPage)
      this.queryInfo.pagenum = newPage;
      this.getFyOrderList();
    },
    CustomeDate() {
      // console.log(this.customdate);
      if (this.customdate == null) {
        this.queryInfo.startTime = "";
        this.queryInfo.endTime = "";
      } else {
        this.queryInfo.startTime = this.customdate[0];
        this.queryInfo.endTime = this.customdate[1];
      }
      this.getOrderList();
    },
    // 导出订单数据
    exportOrders() {
      if (!this.queryInfo.startTime || !this.queryInfo.endTime) {
        this.$message.warning('请选择日期范围')
        return
      }
      const start = new Date(this.queryInfo.startTime)
      const end = new Date(this.queryInfo.endTime)
      const diffDays = Math.floor((end - start) / (1000 * 60 * 60 * 24))
      if (diffDays > 31) {
        this.$message.error('日期范围不能超过31天')
        return
      }
      let downloadLoadingInstance = Loading.service({
        text: "正在下载数据，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axios
        .get("/sendPay/export", {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          responseType: "blob",
          params: this.queryInfo,
        })
        .then(async (data) => {
          const isBlob = data.data.type !== "application/json";
          if (isBlob) {
            const blob = new Blob([data.data]);
            saveAs(blob, `订单数据_${new Date().getTime()}.xlsx`);
          } else {
            this.$message.error("导出订单数据失败");
          }
          downloadLoadingInstance.close();
        })
        .catch((r) => {
          console.error(r);
          this.$message.error("下载文件出现错误，请联系管理员！");
          downloadLoadingInstance.close();
        });
    },
    // 设置表格行的类名
    tableRowClassName({ row }) {
      // 同时满足 doutuiflag=1 和 status=0 的条件才显示浅红色背景
      if (row.doutuiflag == 1 && row.status == 0) {
        return "doutuiflag-row";
      }
      return "";
    },
    async DelCard(row) {
      const confirmResult = await this.$confirm('是否要确认退款抖音的卡'+row.cardname+'吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)

      if (confirmResult !== 'confirm'){

        return this.$message.info('已取消退款！')
      }

      const { data: res } = await this.$http.post("sendPay/updateRefund", row);
      this.isLoading = false
      if (res.status == 1) {
        this.$message.success("操作成功")
        await this.getOrderList()
      } else {
        if (res && res.message) {
          this.$message.error(res.message);
        }
      }
    },
    async ReloadRefundCard(row) {
      const confirmResult = await this.$confirm('是否要重新退款，退款失败的卡'+row.cardname+'吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)

      if (confirmResult !== 'confirm'){

        return this.$message.info('已取消！')
      }

      const { data: res } = await this.$http.post("sendPay/updateRefund", row);
      this.isLoading = false
      if (res.status == 1) {
        this.$message.success("操作成功")
        await this.getOrderList()
      } else {
        if (res && res.message) {
          this.$message.error(res.message);
        }
      }
    },
    async sxCard(row) {
      // 设置退款对话框数据
      this.refundForm = {
        payOrderno: row.payOrderno,
        amount: row.price || 0, // 订单金额
        syAmount: parseFloat((row.price || 0) - (row.cxPrice || 0)).toFixed(2), //剩余可退金额
        sendPrice: null, // 撤销金额，用户输入
        auditReason: "" // 撤销说明，用户输入
      };
      this.refundDialogVisible = true;
    },
    refundDialogClosed() {
      this.$refs.refundFormRef.resetFields();
      // 重置退款表单
      this.refundForm = {
        payOrderno: "",
        amount: 0, // 订单金额
        syAmount: 0, //剩余可退金额
        sendPrice: null, // 撤销金额
        auditReason: "", // 撤销说明
      };
    },
    // 验证退款金额，确保只能输入数字且不超过订单金额
    validateRefundAmount() {
      // 去除非数字字符
      this.refundForm.sendPrice = this.refundForm.sendPrice.replace(
          /[^\d.]/g,
          ""
      );

      // 确保只有一个小数点
      const parts = this.refundForm.sendPrice.split(".");
      if (parts.length > 2) {
        this.refundForm.sendPrice = parts[0] + "." + parts.slice(1).join("");
      }

      // 确保小数点后最多两位
      if (parts.length === 2 && parts[1].length > 2) {
        this.refundForm.sendPrice =
            parts[0] + "." + parts[1].substring(0, 2);
      }

      // 如果输入的金额大于订单金额，自动设置为订单金额
      if (
          this.refundForm.sendPrice &&
          Number(this.refundForm.sendPrice) > Number(this.refundForm.syAmount)
      ) {
        this.refundForm.sendPrice = this.refundForm.syAmount;
        this.$message.info("退款金额不能超过订单金额，已自动调整为订单可退金额");
      }
    },
    // 检查键盘输入，只允许输入数字和小数点
    checkNumberInput(e) {
      // 只允许数字和小数点
      const charCode = e.which ? e.which : e.keyCode;

      // 如果输入的不是数字且不是小数点，阻止输入
      if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
      ) {
        e.preventDefault();
        return false;
      }

      // 如果已经有小数点了，不允许再输入小数点
      if (charCode === 46 && this.refundForm.sendPrice.includes(".")) {
        e.preventDefault();
        return false;
      }

      return true;
    },
    // 处理粘贴事件
    handlePaste(e) {
      // 阻止默认粘贴行为
      e.preventDefault();

      // 获取粘贴的文本
      const pastedText = (e.clipboardData || window.clipboardData).getData(
          "text"
      );

      // 只允许粘贴数字和小数点
      const validText = pastedText.replace(/[^\d.]/g, "");

      // 处理小数点
      let parts = validText.split(".");
      let result = parts[0];
      if (parts.length > 1) {
        result += "." + parts[1].substring(0, 2); // 只保留小数点后两位
      }

      // 将处理后的文本插入到当前值中
      const currentValue = this.refundForm.sendPrice || "";
      const selectionStart = e.target.selectionStart;
      const selectionEnd = e.target.selectionEnd;

      this.refundForm.sendPrice =
          currentValue.substring(0, selectionStart) +
          result +
          currentValue.substring(selectionEnd);

      // 立即验证
      this.validateRefundAmount();
    },
    // 处理中文输入法结束事件
    handleCompositionEnd(e) {
      // 中文输入法完成后立即验证
      this.validateRefundAmount();
    },
    // 提交撤销
    async submitRefund() {
      // 验证表单
      this.$refs.refundFormRef.validate(async (valid) => {
        if (!valid) return;

        // 再次确认
        const confirmResult = await this.$confirm(
            "确定要对此订单进行撤销吗？",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
        ).catch((err) => err);

        if (confirmResult !== "confirm") {
          return this.$message.info("已取消撤销！");
        }

        if (this.refundForm.sendPrice < 1) {
          return this.$message.error("撤销金额最少1元");
        }

        // 发送撤销请求
        const { data: res } = await this.$http.post("sendPay/cxSubmit", this.refundForm);

        if (res.status == 1) {
          this.refundDialogVisible = false;
          this.$message.success(res.message)
          await this.getOrderList()
        } else {
          this.$message({ message: res.message || "撤销失败！", type: "error" });
        }
      });
    },
  },
};
</script>
<style scoped>
.cardcss {
  margin: 5px auto;
  width: 100%;
}
.el-breadcrumb {
  width: 100%;
}
</style>

<!-- 全局样式，不使用scoped，确保可以影响el-table内部元素 -->
<style>
/* 允许表格内容被选择和复制 */
.el-table {
  user-select: text !important;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
}

.el-table__body-wrapper {
  user-select: text !important;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
}

.el-table__body tr,
.el-table__body td {
  user-select: text !important;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
}

/* doutuiflag=1且status=0的行显示浅红色背景 */
.el-table .doutuiflag-row {
  background-color: #ffebeb !important;
}

/* 鼠标悬停时的样式 */
.el-table .doutuiflag-row:hover > td {
  background-color: #ffe0e0 !important;
}

/* 时效卡弹窗样式 */
.gift-card-dialog .el-dialog__header {
  background-color: #f56c6c;
  padding: 15px 20px;
}

.gift-card-dialog .el-dialog__title {
  color: white;
  font-weight: bold;
}

/* 赠卡记录弹窗样式 */
.gift-record-dialog .el-dialog__header {
  background-color: #409eff;
  padding: 15px 20px;
}

.gift-record-dialog .el-dialog__title {
  color: white;
  font-weight: bold;
  font-size: 18px;
}

.gift-card-dialog .el-dialog__body {
  padding: 30px 20px;
}

.gift-card-dialog .el-button--primary {
  background-color: #f56c6c;
  border-color: #f56c6c;
}

.gift-card-dialog .el-button--primary:hover,
.gift-card-dialog .el-button--primary:focus {
  background-color: #f78989;
  border-color: #f78989;
}

.gift-card-dialog .duration-input .el-input__inner:focus {
  border-color: #f56c6c;
}
</style>
